<template>
    <div ref="battery60"></div>
</template>

<script>
import Battery60 from "!!raw-loader!../../assets/ricoh_assets/icons/ICN001-05_battery_60.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.battery60.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = Battery60

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>